import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { Shop } from '../../models/shop.model';

import { ShopProvider } from '../../providers/shop/shop';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-shops',
  templateUrl: 'shops.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class ShopsPage {

  retailerID: number;
  retailerName: string;

  err: string;
  loading: boolean;

  shops: Shop[];

  searchFilter: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, public loadingCtrl: LoadingController, public alertCtrl: AlertController, public shopProvider: ShopProvider) {
    this.retailerID = this.navParams.get('retailerID');
    this.retailerName = navParams.get('retailerName');
  }

  private getShops(retailerID: number) {
    this.loading = true;
    this.shopProvider.getAllByRetailerID(retailerID)
      .subscribe(
        shops => this.shops = shops,
        error => {
          this.err = <any>error;
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  setFilter(ev: any) {
    this.searchFilter = ev.target.value;
  }

  selectShop(shop: Shop) {
    this.viewCtrl.dismiss(shop);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  ionViewDidLoad() {
    this.getShops(this.retailerID);
  }

}



// WEBPACK FOOTER //
// ./src/pages/shops/shops.ts